import { getNavigatorInfo } from '../../utils/navigator.service';

export class LoginCloverRequest {
  public username: string;
  public password: string | undefined;
  public terminal_id: string | undefined;
  public appVersion: string | undefined;
  public version: string | undefined;
  public description: string | undefined;

  constructor() {
    this.username = '';
    this.password = undefined;
    this.terminal_id = undefined;
    this.appVersion = undefined;
    this.version = getNavigatorInfo().version || '4.9.2';
    this.description = 'Pix-Clover';
  }
}
